import { createAction, props } from '@ngrx/store';
import { DropdownData } from '@zayan-erp/shared';

//WarrantyTypes
export const loadWarrantyTypes = createAction('[WarrantyTypes] Load WarrantyTypes');
export const loadWarrantyTypesSuccess = createAction(
  '[WarrantyTypes] Load WarrantyTypes Success',
  props<{ warrantyTypes: DropdownData[] }>()
);

//DeficiencyCode
export const loadDeficiencyCode = createAction(
  '[DeficiencyCode] Load DeficiencyCode',
  props<{ includingInActive?: boolean }>()
);
export const loadDeficiencyCodeSuccess = createAction(
  '[DeficiencyCode] Load DeficiencyCode Success',
  props<{ deficiencyCode: DropdownData[] }>()
);

export const loadLocations = createAction('[Locations] Load Locations', props<{ includingInActive?: boolean }>());
export const loadLocationsSuccess = createAction(
  '[Locations] Load Locations Success',
  props<{ locations: DropdownData[] }>()
);

//selectedDeficiencyCode
export const selectedCategoryId = createAction(
  '[selectedCategoryId] Load selectedCategoryId',
  props<{ categoryId: string | null }>()
);

//categoryLocation
export const loadCategoryLocation = createAction(
  '[loadCategoryLocation] Load loadCategoryLocation',
  props<{ categoryLocation: { [categoryId: string]: DropdownData[] } }>()
);
